import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../Logic/GameLogic';
import { PlayerModel } from '../../Models/Game/PlayerModel';

export class UITimeController extends AnimationBaseController {
    $model: PlayerModel;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic) {
        super('UITimeController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {
                time: (value: number) => {
                    this.setTime(this._gameLogic.secondsToHHMMSS(value));
                },
            },
        };
    }

    protected onInitialize(): void {
        this.setTime(this._gameLogic.secondsToHHMMSS(this.$model.time));
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.x = width / scale / 2 - 750;
    }

    private setTime(value: string): void {
        this.setTextByQuery('text', value);
    }
}
